import styled from "styled-components";

const SongListStyles = styled.ul`
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export default SongListStyles;
